import React from 'react';

import {IconProps} from './props';


const InvalidIcon = ({width, height}: IconProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd"
            d="M9 0C4.032 0 0 4.032 0 9C0 13.968 4.032 18 9 18C13.968 18 18 13.968 18 9C18 4.032 13.968 0 9 0ZM7.60687 5.24619C7.54912 4.4377 8.18945 3.75 9 3.75C9.81055 3.75 10.4509 4.4377 10.3931 5.24619L10.0712 9.75254C10.0311 10.3146 9.56345 10.75 9 10.75C8.43655 10.75 7.9689 10.3146 7.92875 9.75254L7.60687 5.24619ZM9 12C8.30964 12 7.75 12.5596 7.75 13.25C7.75 13.9404 8.30964 14.5 9 14.5C9.69036 14.5 10.25 13.9404 10.25 13.25C10.25 12.5596 9.69036 12 9 12Z"
            fill="#EB5757"
      />
    </svg>
  );
};

export default InvalidIcon;